import React from "react";
import Alert from 'react-bootstrap/Alert';
import style from "../header.module.css";
import Date from "../Date";

const TechCom=()=>{
const list_of_tec = [
    "Prof (Dr.) Vincenzo Piuri, University of Milan, Italy",
    "Prof (Dr.) Marius Balas, Aurel Vlaicu University of Arad, Romania",
    "Prof (Dr.) Aboul Ella Hassanien, Cairo University, Egypt",
    "Prof (Dr.) Cenap Ozel, King Abdulaziz University, Saudi Arabia",
    "Prof (Dr.) Ashiq Anjum, University of Derby, Bristol, UK",
    "Prof (Dr.) Mischa Dohler, King’s College London, UK",
    "Prof (Dr.) David Camacho, Associate Prof, Universidad Autonoma de Madrid, Spain",
    "Dr. Abu Yousuf, Asst. Prof University Malaysia Pahang Gambang, Malaysia",
    "Prof (Dr.) Salah-ddine Krit, University Ibn Zohr – Agadir, Morocco",
    "Dr. Sanjay Kumar Biswash, Research Scientist INFOCOMM Lab, Russia",
    "Prof (Dr.) Maryna Yena S, Senior Lecturer Medical University of Kiev, Ukraine",
    "Prof (Dr.) Giorgos Karagiannidis, Aristotle University of Thessaloniki, Greece",
    "Prof (Dr.) Tiziana Catarci, Sapienza University, Rome, Italy",
    "Prof (Dr.) Salvatore Gaglio, University Degli Studi di Palermo, Italy",
    "Prof (Dr.) Bozidar Klicek, University of Zagreb, Croatia",
    "Prof (Dr.) Chang-Shing Lee, National University of Tainan, Taiwan",
    "Dr. Paolo Bellavista, Associate Prof, Alma Mater Studiorum–Università di Bologna",
    "Prof (Dr.) Benatiallah Ali, Associate Professor Adrar University, Algeria",
    "Prof (Dr.) Marylene Saldon-Eder, Mindanao University of Science and Technology",
    "Prof (Dr.) Özlem ONAY, Anadolu University, Eskisehir TURKEY",
    "Miss Rubelyn W. Coronel, Datu Abing St., Calinan, Davao City",
    "Prof (Dr.) Kei Eguchi, Dept. of Information Electronics, Fukuoka Institute of Technology",
    "Prof (Dr.) Zoltan Horvath, Professor, Kasetsart University",
    "Dr. AKM Matiul Alam, Vancouver British Columbia, Canada",
    "Prof (Dr.) Joong Hoon Jay Kim, Korea University",
    "Prof (Dr.) Sheng-Lung Peng, National Dong Swa University, Taiwan",
    "Dr. Daniela Lopez De Luise, CI2S Lab, Argentina",
    "Dr. Dac-Nhuong Le, Haiphong University, Vietnam",
    "Dr. Dusanka Boskovic, University of Sarajevo, Sarajevo",
    "Dr. Periklis Chat Zimisios, Alexander TEI of Thessaloniki, Greece",
    "Dr. Atta Ur Rehman Khan, KSU and CIIT",
    "Dr. Nhu Gia Nguyen, Duy Tan University, Vietnam",
    "Prof (Dr.) Huynh Thanh Binh, Hanoi University of Science & Technology, Vietnam",
    "Dr. Ahmed Faheem Zobaa, Brunel University, London",
    "Dr. Kirti Tyagi, Inha University, Tashkent",
    "Prof (Dr.) Ladjel Bellatreche, Poitiers University, France",
    "Prof (Dr.) Victor C.M. Leung, The University of British Columbia, Canada",
    "Prof (Dr.) Huseyin Irmak, Cankiri Karatekin University, Turkey",
    "Dr. Alex Norta, Associate Professor, Tallinn University of Technology, Estonia",
    "Prof Christos Douligeris, University of Piraeus, Greece",
    "Dr. Brett Edward Trusko, President & CEO(IAOIP) and Assistant Professor, Texas A&M University, Texas",
    "Dr. Vikas Chaudhary, Madda Walabu University, Ethiopia",
    "Dr. Hamid R Arabnia, University of Georgia, USA",
    "Prof (Dr.) Akshaye Dhawan, Ursinus College, Pennsylvania, USA",
    "Dr. Nguyen Ha Huy Cuong, Lecturer, Quang Nam University, Tam Ky City, Vietnam",
    "Dr. Aleksandar Mastilovic, University of Novi Sad, Serbia",
    "Dr. Mohamed Mostafa Fouad, Arab Academy for Science and Technology, Egypt",
    "Prof (Dr.) Maryna Yena S, Senior Lecturer Medical University of Kiev, Ukraine",
    "Prof (Dr.) Benatiallah Ali, Associate Professor, Engineering Department, Adrar University, Algeria",
    "Andri Pranolo, Universitas Ahmed Dahlan, Indonesia",
    "Dr. Simranjeet Kaur, Post Doctor Researcher, Copenhagen Diabetes Research Center, Herlev Hospital, Herlev Denmark",
    "Dr. Jitendra Narayan, PostDoc Research Scientist, University of Namur (UNamur), Department of Biology (URBE), Belgium",
    "Mr. Ashutosh Kaushik, Software Engineer, Synopsys, California USA",
    "Mr. Amarjeet Raghav, Software Engineer, TCS, Washington DC USA",
    "Mr. Ankur Verma, Software Engineer, Thyssenkrupp Tallent, UK",
    "Mr. Rajesh Kumar, Software Engineer, TCS, USA",
    "Prof(Dr.) Tanuja SRIVASTAVA, Department of Mathematics, Indian Institute of Technology, Roorkee",
    "Prof(Dr.) Parmanand, Dean, Sharda University, UP, India",
    "Dr. Rajesh Kumar, CSE Dept, Thapar University, Punjab, India",
    "Dr. Uday Shankar, Deen Dayal Uppadhayay, UP, India",
    "Dr. Dhurender, IT Dept, Netaji Subhash Institute of Technology, Delhi",
    "Dr. Kapil Sharma, Professor, Delhi Technological University, Delhi, India",
    "Dr. Manish Madan, Chairman, AIRDO, Delhi, India",
    "Dr. Amar Mohapatra, Professor, IGDTUW, Delhi, India",
    "Prof (Dr.) Amit Prakash Singh, GGSIPU, Delhi, India",
    "Dr. PS Rana, Associate Professor, Thapar University, Punjab, India",
    "Prof (Dr.) Himani Bansal, JIIT, Noida, India",
    "Dr. Brojo Kishore Mishra, Associate Professor, CV Raman College of Engineering, Bhubaneshwar",
    "Dr D.V. Ashoka, Professor, JSS Academy of Technical Education, Bangalore, India",
    "Dr. Thippeswamy G, Professor & HOD Computer Science BMS Institute of Technology, Bangalore",
    "Dr. Vinod Kumar Verma, Sant Longowal Institute of Engineering & Technology, (Deemed University), Punjab, India",
    "Prof D. P. Mishra, Prof. In-Charge T & P Cell Asso. Prof. Bhilai Institute of Technology, Bhilai House, Durg, CG",
    "Dr. Debabrata Samanta, Associate professor, Dayananda Sagar College of Arts, Science and Commerce, Bangalore, India",
    "Prof. Meenu Vijarania, Assistant Professor Department of Computer Science Amity University Haryana",
    "Dr. Manjesh, Associate Professor Bangalore University, Bangalore",
    "Dr. V. PUSHPARAJESH, Kongu Engineering College, India",
    "Prof(Dr.) R.Shivakumar, Sona College of Technology, Salem, India",
    "Prof.(Dr.) K.P. Yadav, Director KCC Institute of Technology & Management, Greater Noida",
    "Dr. T.R. Sumithira, K.S.R. College of Engineering, Tiruchengode",
    "Dr. S.ALBERT ALEXANDER, Kongu Engineering College Perundurai, Tamilnadu, India",
    "Dr. Ganesh Venkatesan, Managing Director, Elsevier, Chennai, India",
    "Dr. Deepti Mehrotra, Amity University, Noida, India",
    "Prof (Dr.) Himanshu Agarwal, Punjabi University, Patiala, India",
    "Prof (Dr.) Sujata Pandey, Amity University, Noida, India",
    "Prof (Dr.) Anil Kumar Ahlawat, KIET Group of Institutes, India",
    "Dr. Hanumat G Sastry, Associate Professor, UPES, Dehradun, India",
    "Mr. Jayraj Ugarkar, Head, Internet of Things, Infosys, Bangalore, India",
    "Dr. Babita Pandey, Associate Professor School of Computer Application Lovely Professional University",
    "Dr. Samarjeet Borah, Associate Professor, Sikkim Manipal Institute of Technology, India",
    "Dr. Uzzal Sharma, Associate Professor Department of Computer Science & Engineering,Assam Don Bosco University",
    "Dr. NANDINI PRASAD K S, Associate Professor Department of Computer Science & Engineering, AIT, Bangalore",
    "Prof. (Dr.) Abdul Wahid, Maulana Azad National Urdu University, Hyderabad",
    "Dr. P. Maruthupandi, Government College of Technology, Coimbatore",
    "Prof (Dr.) A. Mahabub Basha, K.S.R. College of Engineering, Tiruchengode, Tamilnadu, India",
    "Prof(Dr.) C.NAGARAJAN, Muthayammal College of Engineering Rasipuram, Namakkal, India",
    "Dr. Telagarapu.Prabhakar, GMR Institute of Technology (GMRIT), Rajam, Srikakulam District, A.P",
    "Dr. Gurpreet Singh, Giani Zail Singh Campus College of Engineering & Technology, Maharaja Ranjit Singh Punjab Technical University, Bathinda, India",
    "Dr. Anil Verma, Thapar University, Patiala, India",
    "Prof (Dr.) Mangey Ram Swami, Graphic Era University, Dehradun, India",
    "Dr. Swagatam Das, Professor, Indian Statistical Institute, Kolkata, India",
    "Prof (Dr.) Abhishek Swaroop, Bhagwan Parshuram Institute of Technology, Delhi",
    "Dr. Hemraj Saini, Associate Professor, Jaypee University of Information Technology, Waknaghat, India",
    "Prof (Dr.) Prasanta Jana, Indian Institute of Technology, Dhanbad, India",
    "Dr. Sandeep Chaurasia, Associate Professor, Manipal University, Jaipur, India",
    "Dr. Manish Saini, Assistant Professor, DCRUST, Haryana, India",
    "Dr. Seema Verma, Associate Professor , Banasthali Vidyapith, Rajasthan, India",
    "Dr. Om Prakash Sangwan, Associate Professor, Guru Jambheshwer University of Science & Technology,, Hissar, India",
    "Dr. Vishal Goyal, Associate Professor, GLA University , Mathura, India",
    "Prof (Dr.) Atul Gonsai, Saurashtra University, Rajkot",
    "Prof (Dr.) Shashikant Patil, Shirpur",
    "Prof. (Dr.) Udayan Ghosh, Professor, GGSIPU, Delhi",
    "Dr. Venkatadri Marriboyina, Associate Professor, UPES, Dehradun",
    "Prof (Dr.) Rama Kishore, Professor, GGSIPU, Delhi",
    "Prof. (Dr.) Achal Kaushik, Bhagwan Parshuram Institute of Technology, Delhi",
    "Prof (Dr.) Ruchika Malhotra, Associate Professor, DTU, Delhi, India",
    "Dr. Mahesh, Associate Professor, JUIT, Guna",
    "Prof. (Dr.) Awdesh Singh, Professor, Galgotia university, UP, India",
    "Dr. Shikha Jain, Associate Professor, JUIT Noida, India",
    "Dr. Bharti Sharma, Associate Professor, NIT Kurukshetra, India",
    "Dr. Parmit Kaur, Associate Professor, JUIT, Noida, India",
    "Dr. Deepak Sharma, Associate Professor, IGDTUW, India",
    "Dr. Arun Sharma, Associate Professor, IGDTUW, Delhi, India",
    "Dr. Jyotsna Sinha, Director, RCIT, GGSIPU, India",
    "Dr. PS Bedi, Guru Tegh Bahadur Institute of Technology, GGSIPU, Delhi, India",
    "Dr. Mayur Bhoyar, Jagdamba College of Engg and Tech, India",
    "Dr. S.Nagaprasad, S.R.R.Govt.Arts & Science College, Karimnagar, Telangana",
    "Dr. Preeti Nagrath , Associate Professor, Bharati Vidyapeeth college of Engineering, India",
    "Dr. Rachna Jain , Associate Prof., BPIT, GGSIPU, Delhi, India",
    "Dr. Ankur Saxena, Amity University Uttar Pradesh, Noida U.P",
    "Dr. Nidhee Chaudhary, Professor, Amity University Uttar Pradesh Noida, India",
    "Dr. Puniti Mathur, Assistant Professor, Amity University Uttar Pradesh Noida, India",
    "Dr. Shivani Chandra, Assistant Professor, Amity University Uttar Pradesh Noida, India",
    "Dr. Sumit Kumar, KIET Group of Institute, AKTU ,U.P., India",
    "Dr.Yugal Kumar, JP University Solan, H.P, India",
    "Dr. Neeraj Rathore, India.neerajrathore37@gmail.com, Assistant Prof., Deptt. of CSE, Jaypee University of Engg. and Technology, Guna, M.P.",
    "Dr. Nilesh Jain, Assistant Prof., Jaypee University of Engg. & Technology, Guna, M.P.",
    "Dr. Anirban Mitra, Associate Professor, Department of Computer Science Engineering, Gandhi Engineering College, Bhubaneswar, Odishan",
    "Prof. C. S. Rai, USICT, GGSIP University, New Delhi",
    "Dr. Deepika Kukreja, Assistant Professor, NSIT, New Delhi",
    "Dr. Lalit Goyal, Assistant Professor, Bhartiya Vidyapeeth’s College of Engineering, New Delhi",
    "Dr. Sudeep Tanwar, Professor, Department of Computer Engineering, Institute of Technology, Nirma University, Ahmedabad, Gujarat, India",
    "Dr. Priyanka Sharma, Department of Computer Engineering, Institute of Technology, Nirma University, Ahmedabad, Gujarat, India",
    "Balamurugan Shanmugam, Director-Research and Development, Mindnotix Technologies, India",
    "Arunn Vignesh Ganesan, Research Associate, Mindnotix Technologies, India"
  ];
  
  

return(
    <div>
        <h2 class={style.abtHeader}>Technical Committee</h2>
        <hr />
        <div className={style.flex}>
        <div className={style.techCont}>
            {list_of_tec.map(mem=>{
                return(
                    <Alert className={style.techMem}><p style={{fontWeight:"500",width:"300px",fontSize:"14px"}}>{mem}</p></Alert>
                );
            }) 
            }
        </div>
        <Date />
        </div>
        
    </div>
)
}
export default TechCom;